import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import riverIceDataTransform from '../utility/iceDataTransform'

const transform = geoJson => {
  const properties = getFeaturesFromGeoJson(geoJson)
  const data = riverIceDataTransform(properties)

  return data
}

export default transform



// WEBPACK FOOTER //
// ./src/utility/getRiverIceDataFromGeoJson.js